import axios from "axios";
import { API } from "@/lib/api";

/**
 * K2 van blok K, werk per team (Frank, 18 oktober 2026): het actieve team.
 *
 * Een team is de werkruimte van een bedrijf. Persoonlijk is de standaard en
 * staat altijd bovenaan. De backend beslist of een keuze telt
 * (`services/team_werk.actief_team`, K1): alleen een team waar je lid van bent,
 * een verdwenen team leest als persoonlijk.
 *
 * De zijbalk en de Teams-pagina kunnen allebei wisselen. Na een wissel gaat er
 * een vensterbericht uit, zodat de ander meeloopt zonder opnieuw te vragen.
 */

export const PERSOONLIJK = "";
export const WISSEL_BERICHT = "novamund:actief-team";

/** De opties van de kiezer: Persoonlijk eerst, dan de teams. PUUR. */
export function kiezerOpties(teams, t = (s) => s) {
  const lijst = Array.isArray(teams) ? teams : [];
  return [
    { id: PERSOONLIJK, naam: t("Persoonlijk") },
    ...lijst.filter((team) => team && team.id).map((team) => ({ id: team.id, naam: team.name })),
  ];
}

/** K3: waar een gesprek heen kan, alle werkruimtes behalve de huidige. PUUR. */
export function verplaatsDoelen(teams, actief, t = (s) => s) {
  return kiezerOpties(teams, t).filter((o) => o.id !== (actief || PERSOONLIJK));
}

/** Wat de backend teruggeeft, als waarde voor de kiezer. PUUR. */
export function alsKeuze(antwoord) {
  return antwoord && antwoord.team_id ? antwoord.team_id : PERSOONLIJK;
}

export async function leesActiefTeam() {
  const resp = await axios.get(`${API}/teams/actief`);
  return alsKeuze(resp.data);
}

export async function zetActiefTeam(id) {
  const resp = await axios.put(`${API}/teams/actief`, { team_id: id || null });
  const keuze = alsKeuze(resp.data);
  window.dispatchEvent(new CustomEvent(WISSEL_BERICHT, { detail: keuze }));
  return keuze;
}

/**
 * K7a: heeft een ANDER apparaat gewisseld? Mac en telefoon delen het actieve team,
 * maar alleen het apparaat dat wisselt hoort het bericht. Dit leest het team
 * opnieuw en stuurt bij een verschil hetzelfde wisselbericht, zodat alles op dit
 * apparaat meeloopt zoals bij een eigen wissel. Geeft het team van nu terug.
 */
export async function volgWissel(huidig) {
  const nu = await leesActiefTeam();
  if (nu !== (huidig || PERSOONLIJK)) {
    window.dispatchEvent(new CustomEvent(WISSEL_BERICHT, { detail: nu }));
  }
  return nu;
}

/** K3: een gesprek naar een andere werkruimte. */
export async function verplaatsGesprek(gesprekId, teamId) {
  await axios.put(`${API}/conversations/${gesprekId}/team`, { team_id: teamId || null });
}
